import enLang from "./entries/en-US";
import viLang from "./entries/vi_VN";

const AppLocale = {
  en: enLang,
  vi: viLang,
};

export default AppLocale;
